import { Gesture } from "./BaseGesture"

export default function () {
  const { state: gestureState, gestureLayers } = useGestures()
  const { addFilesToSidebar, state: sidebarState } = useSidebar()
  const { selectedFiles, isSelectionEmpty } = useSelection()
  const { sidebarFavoritesId } = useGlobals()
  const { moveFiles } = useFileSystem()

  class SidebarFileDropToAddToFavorites extends Gesture {
    override layer = gestureLayers.sidebar
    #offsetTop = 48
    #favoriteHeight = 24
    #favoriteGap = 8

    override reset() {
      gestureState.value.sidebarFavoritesFileDraggedOver = undefined
      gestureState.value.sidebarFavoritesDraggedBetween = undefined
    }

    isOverFavorites(event: MouseEvent) {
      return getFirstMatchingParent(event.target, e => e.id === sidebarFavoritesId)
    }

    override async onMouseMove(mouse: MouseEvent) {
      const favorites = this.isOverFavorites(mouse)
      if (!gestureState.value.mouseDown || gestureState.value.gesture !== "drag-file" || !favorites) {
        return this.reset()
      }

      return // FIXME: implement drag and drop for sidebar

      // check where we are in favorites, and then set sidebar variables for that
      // set file dragged over if we are dragging over a file

      // TODO: how to tell if dragging between?

      const { clientY } = gestureState.value.mousePosition!
      const { top } = favorites.getBoundingClientRect()
      const offsetY = clientY - top - this.#offsetTop

      const sortedSidebarFiles = ref([]) // FIXME

      // we are hovered over a file if we are in the first 24 px, then we are between if we
      // are in the next 8. We are at the beginning if idx < 0, end if idx >= length
      const idx = Math.floor(offsetY / (this.#favoriteHeight + this.#favoriteGap))
      const idxDist = offsetY - (idx * (this.#favoriteHeight + this.#favoriteGap))
      const maybeFile = sortedSidebarFiles.value[idx]
      const maybeFileNext = sortedSidebarFiles.value[idx + 1]

      if (maybeFile && idxDist <= this.#favoriteHeight) {
        if (maybeFile.file.isFolder())
          gestureState.value.sidebarFavoritesFileDraggedOver = maybeFile.file
        gestureState.value.sidebarFavoritesDraggedBetween = undefined
      }
      else {
        gestureState.value.sidebarFavoritesFileDraggedOver = undefined
        gestureState.value.sidebarFavoritesDraggedBetween = [maybeFile?.fractionalIndex, maybeFileNext?.fractionalIndex]
      }

      this.capture()
    }

    override async onMouseUp(mouse: MouseEvent) {
      if (gestureState.value.gesture !== "drag-file" || !this.isOverFavorites(mouse) || isSelectionEmpty())
        return this.reset()

      if (!isDefined(gestureState.value.sidebarFavoritesFileDraggedOver) && !isDefined(gestureState.value.sidebarFavoritesDraggedBetween))
        return this.reset()

      const files = selectedFiles.value

      this.debug("Dropped files over sidebar", files)
      this.capture()

      if (isDefined(gestureState.value.sidebarFavoritesFileDraggedOver)) {
        moveFiles(selectedFiles.value, gestureState.value.sidebarFavoritesFileDraggedOver)
      }
      else if (isDefined(gestureState.value.sidebarFavoritesDraggedBetween)) {
        addFilesToSidebar(selectedFiles.value, gestureState.value.sidebarFavoritesDraggedBetween)
      }

      this.reset()
      this.capture()
    }
  }
  return new SidebarFileDropToAddToFavorites()
}
